import React, { useState } from "react";
import '../Styles/components.css';
import './CardStyles/CardC.css';
import { MdShoppingCart } from "react-icons/md";
import PopUp from "../PopUps/AddToCart_Popup/PopUp";

const PopupLayout = [{
  des: "none",
  options: "none",
  additional: "block",
  specialInstructions: "block",
}];

const CardC = (props, { children, className, ...restProps }) => {

  const [openModal, setOpenModal] = useState(false);

  const Popup = () => {
    setOpenModal(true);
    // Disables Background Scrolling whilst the SideDrawer/Modal is open
    if (typeof window != 'undefined' && window.document) {
      document.body.style.overflow = 'hidden';
    }

  }
  const ClosePopup = () => {
    setOpenModal(false);
    // Disables Background Scrolling whilst the SideDrawer/Modal is open
    document.body.style.overflow = 'unset';
  }
  return (
    <div onClick={Popup} {...restProps} className={`theme-div CardC-div ${className}`} >
      <div className={`theme-div CardC-div-0`}>
        <div className={`theme-div CardC-div-1`}>
          <div className={`theme-div CardC-div-9`}>
            <picture className={`theme-picture CardC-picture`}>
              <img className={`theme-img CardC-img`} alt=""
                src={props.img} />
            </picture>
          </div>
          <div className={`theme-div CardC-div-2`}>
            <div className={`theme-div CardC-div-3`}>
              <div className={`theme-div CardC-div-4`}>
                <div className={`theme-div CardC-div-5`}>
                  <h2 className={`theme-h2 CardC-h2`} children={props.name} />
                </div>
                <div className={`theme-div CardC-div-6`}>
                  <p className={`theme-p CardC-p`} children={props.des} />
                </div>
              </div>
              <div className={`theme-div CardC-div-7`}>
                <div className={`theme-div CardC-div-8`}>
                  <span className={`theme-span CardC-span`}>Rs.{props.price} </span>
                </div>
              </div>
              <button className={`theme-button CardC-button`} type="button">
                <p>Add To Cart <MdShoppingCart style={{ marginBottom: "-2%" }}></MdShoppingCart></p>
              </button>
            </div>
          </div>
        </div>
      </div>

      {PopupLayout.map((display) => (
        <PopUp
          key={props.id}
          open={openModal}
          onClose={ClosePopup}
          name={props.name}
          id={props.id}
          price={props.price}
          des={props.des}
          img={props.img}
          displayDes={display.des}
          displayOption={display.options}
          displayAdditional={display.additional}
          displaySpecialInstruction={display.specialInstructions}
        />
      ))}
    </div>

  );

};
CardC.defaultProps = {
  name: "Name",
  price: "Price",
  img: "https://admin.indolj.io/upload/1679656815-WhatsApp%20Image%202023-03-24%20at%2010.29.36%20AM.jpeg",
  des: "lorem ipsum "
}
export default CardC;